<template>
    <v-container class="catalogue-awards" grid-list-xl>

        <!-- Ордена -->
        <DescriptionCard v-bind:awards="awards.orders" />
        
        <!-- <DescriptionCard_v2 v-bind:awards="awards.orders" /> -->

        <!-- Медали БГС -->
        <DescriptionCard v-bind:awards="awards.medals.bgs" />

        <!-- Медали ПП -->
        <DescriptionCard v-bind:awards="awards.medals.pp" />

        <!-- Медали AX -->
        <DescriptionCard v-bind:awards="awards.medals.ax" />
        
        <!-- Общие медали -->
        <DescriptionCard v-bind:awards="awards.medals.general" />

        <!-- Памятные медали -->
        <DescriptionCard v-bind:awards="awards.medals.commemorative" />

        <!-- Прочие награды -->
        <DescriptionCard v-bind:awards="awards.other" />

    </v-container>
</template>

<script>
export default {
    components: {
        DescriptionCard: () => import('@/components/DescriptionCard')
        // DescriptionCard_v2: () => import('@/components/DescriptionCard_v2')
    },
    data: () => ({
        awards: {
            orders: {
                title: "Ордена",
                list: [
                    "Эвриалы-1-й-степени",
                    "Эвриалы-2-й-степени",
                    "Эвриалы-3-й-степени",
                    "Гвардия-Диктатора-1-я-степень",
                    "Гвардия-Диктатора-2-й-степени",
                    "Гвардия-Диктатора-3-й-степени",
                    "Гвардия-Диктатора-4-й-степени",
                    "За-особые-заслуги-1-й-степени",
                    "За-особые-заслуги-2-й-степени",
                    "За-особые-заслуги-3-й-степени",
                    "Цитадель"
                ]
            },
            medals: {
                bgs: {
                    title: "Медали БГС",
                    list: [
                        "За-независимость",
                        "За-покорение",
                        "За-оборону",
                        "Зубр-BGS"
                    ]
                },
                pp: {
                    title: "Медали ПП",
                    list: [
                        "Кузнец-Победы",
                        "За-оборону-Державы",
                        "За-взятие"
                    ]
                },
                ax: {
                    title: "Медали AX",
                    list: ["Защитник-галактики"]
                },
                general: {
                    title: "Общие медали",
                    list: [
                        "Границы-неизведанного",
                        "Боец-невидимого-фронта",
                        "За-содействие",
                        "Переговорщик"
                    ]
                },
                commemorative: {
                    title: "Памятные медали",
                    list: [
                        "Rise-to-Power",
                        "Wildcard",
                        "Инь-Янь"
                    ]
                }
            },
            other: {
                title: "Прочие награды",
                list: ["Почетная-грамота"]
            }
        }
    })
}
</script>